import React from 'react';
import { observer } from 'mobx-react';
import { Divider } from 'antd';
import {
    BorderlessTableOutlined,
    CalculatorOutlined,
    DeleteColumnOutlined,
    RedEnvelopeOutlined,
} from '@ant-design/icons';
import { IFieldLayout } from '../../../interfaces';
import { useCompanyInfo, useCompanyTenantConfig } from '../../../hooks';
import { ITrField, tF } from '../../../translate';
import { FieldInfoAdvanced, ShowBooleanEDField } from '../../Forms';
import Styles from '../../styles/m_itemCardStyles.less';

type IShowCompanyInfoTenantConfig = {
    layout?: IFieldLayout;
};
// ToDo: 19.03.2026 -  add translate label
export const ShowCompanyInfoTenantConfig: React.FC<IShowCompanyInfoTenantConfig> = observer(
    ({
        layout = {
            labelCol: {
                flex: '0 1 350px',
            },
            valCol: {
                flex: '1 1 80px',
            },
            rowGutter: 8,
        },
    }: IShowCompanyInfoTenantConfig) => {
        const { isTenantConfig } = useCompanyInfo();
        const tenantConfig = useCompanyTenantConfig();

        return isTenantConfig ? (
            <>
                <Divider>{tF('Tenant config' as ITrField)}</Divider>
                <FieldInfoAdvanced
                    icon={<CalculatorOutlined className={Styles.labelIcon} />}
                    layout={layout}
                    title={'Multiplier for KB/MB/GB' as ITrField}
                    dataTest={'bytesPerKb'}
                >
                    {tenantConfig.bytesPerKb}
                </FieldInfoAdvanced>
                <FieldInfoAdvanced
                    icon={<DeleteColumnOutlined className={Styles.labelIcon} />}
                    layout={layout}
                    title={'Hide costs column for CDRs' as ITrField}
                    dataTest={'hideCosts'}
                >
                    <ShowBooleanEDField field={tenantConfig.hideCosts} />
                </FieldInfoAdvanced>
                <FieldInfoAdvanced
                    icon={<BorderlessTableOutlined className={Styles.labelIcon} />}
                    layout={layout}
                    title={'Show Product ID and Package Type in tariffs' as ITrField}
                    dataTest={'showPackageData'}
                >
                    <ShowBooleanEDField field={tenantConfig.showPackageData} />
                </FieldInfoAdvanced>
                <FieldInfoAdvanced
                    icon={<RedEnvelopeOutlined className={Styles.labelIcon} />}
                    layout={layout}
                    title={'Require tariff' as ITrField}
                    dataTest={'showRequireTariff'}
                >
                    <ShowBooleanEDField field={tenantConfig.requireTariff} />
                </FieldInfoAdvanced>
            </>
        ) : null;
    },
);
